// extracted by mini-css-extract-plugin
export default {"reactMarkDown":"terms-of-service_reactMarkDown__169Jd"};